var _style, _path, _path2, _g, _g2, _defs, _defs2, _defs3, _defs4, _path3, _path4, _path5, _path6, _defs5, _path7, _path8, _path9, _defs6, _path10, _g3, _defs7, _path11, _path12, _g4, _defs8, _path13, _path14, _defs9, _defs10, _defs11, _path15, _path16, _path17, _path18, _g5, _path19, _defs12, _defs13, _g6, _path20, _path21, _path22, _path23, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrainThinking01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 962.7 599.2",
    style: {
      enableBackground: "new 0 0 962.7 599.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{clip-path:url(#SVGID_4_);fill:#F9F9F9;}\n\t.st2{clip-path:url(#SVGID_6_);fill:#F9F9F9;}\n\t.st3{clip-path:url(#SVGID_8_);fill:#008080;}\n\t.st4{clip-path:url(#SVGID_10_);fill:#07AAA5;}\n\t.st5{clip-path:url(#SVGID_12_);fill:#FFFFFF;}\n\t.st6{clip-path:url(#SVGID_14_);fill:#102A54;}\n\t.st7{clip-path:url(#SVGID_16_);fill:#F9F9F9;}\n\t.st8{clip-path:url(#SVGID_18_);fill:#F9F9F9;}\n\t.st9{clip-path:url(#SVGID_20_);fill:#F9F9F9;}\n\t.st10{clip-path:url(#SVGID_22_);fill:#F9F9F9;}\n\t.st11{clip-path:url(#SVGID_24_);fill:#F9F9F9;}\n\t.st12{clip-path:url(#SVGID_26_);fill:#F9F9F9;}\n\t.st13{clip-path:url(#SVGID_28_);fill:#102A54;}\n\t.st14{clip-path:url(#SVGID_30_);fill:#FFFFFF;}\n\t.st15{opacity:0.61;clip-path:url(#SVGID_32_);fill:#F9F9F9;enable-background:new    ;}\n\t.st16{opacity:0.26;clip-path:url(#SVGID_34_);fill:#3C94F8;enable-background:new    ;}\n\t.st17{opacity:0.18;clip-path:url(#SVGID_36_);fill:#3C94F8;enable-background:new    ;}\n\t.st18{opacity:0.1;clip-path:url(#SVGID_38_);fill:#3C94F8;enable-background:new    ;}\n\t.st19{opacity:0.14;clip-path:url(#SVGID_40_);fill:#3C94F8;enable-background:new    ;}\n\t.st20{clip-path:url(#SVGID_42_);fill:#F9F9F9;}\n\t.st21{clip-path:url(#SVGID_44_);fill:#102A54;}\n\t.st22{clip-path:url(#SVGID_46_);fill:#102A54;}\n\t.st23{clip-path:url(#SVGID_48_);fill:#6CB597;}\n\t.st24{clip-path:url(#SVGID_50_);fill:#102A54;}\n\t.st25{clip-path:url(#SVGID_52_);fill:#102A54;}\n\t.st26{clip-path:url(#SVGID_54_);fill:#6CB597;}\n\t.st27{clip-path:url(#SVGID_56_);fill:#102A54;}\n\t.st28{clip-path:url(#SVGID_58_);fill:#F99747;}\n\t.st29{clip-path:url(#SVGID_60_);fill:#FFC0B1;}\n\t.st30{clip-path:url(#SVGID_62_);fill:#006663;}\n\t.st31{clip-path:url(#SVGID_64_);fill:#008080;}\n\t.st32{clip-path:url(#SVGID_66_);fill:#0C203F;}\n\t.st33{clip-path:url(#SVGID_68_);fill:#102A54;}\n\t.st34{clip-path:url(#SVGID_70_);fill:#FFC0B1;}\n\t.st35{clip-path:url(#SVGID_72_);fill:#102A54;}\n\t.st36{clip-path:url(#SVGID_74_);fill:#FFFFFF;}\n\t.st37{clip-path:url(#SVGID_76_);fill:#102A54;}\n\t.st38{clip-path:url(#SVGID_78_);fill:#102A54;}\n\t.st39{clip-path:url(#SVGID_80_);fill:#FFC0B1;}\n\t.st40{clip-path:url(#SVGID_82_);fill:#102A54;}\n\t.st41{clip-path:url(#SVGID_84_);fill:#F99747;}\n\t.st42{clip-path:url(#SVGID_86_);fill:#102A54;}\n\t.st43{clip-path:url(#SVGID_88_);fill:#F99747;}\n\t.st44{clip-path:url(#SVGID_90_);fill:#102A54;}\n\t.st45{clip-path:url(#SVGID_92_);fill:#102A54;}\n\t.st46{clip-path:url(#SVGID_94_);fill:#FFC0B1;}\n\t.st47{clip-path:url(#SVGID_96_);fill:#FFC0B1;}\n\t.st48{clip-path:url(#SVGID_98_);fill:#102A54;}\n\t.st49{clip-path:url(#SVGID_100_);fill:#7FC0FF;}\n\t.st50{clip-path:url(#SVGID_102_);fill:#7FC0FF;}\n\t.st51{clip-path:url(#SVGID_104_);fill:#102A54;}\n\t.st52{clip-path:url(#SVGID_106_);fill:#D2FFFE;}\n\t.st53{clip-path:url(#SVGID_108_);fill:#008080;}\n\t.st54{clip-path:url(#SVGID_110_);fill:#04AFAA;}\n\t.st55{fill:none;}\n\t.st56{fill:#2F3050;}\n\t.st57{fill:#1A1924;}\n\t.st58{fill:#4C4F81;}\n\t.st59{fill:#222231;}\n\t.st60{fill:#FFFFFF;}\n\t.st61{fill:#00B0C2;}\n\t.st62{fill:#E64645;}\n\t.st63{fill:#009EE2;}\n\t.st64{fill:#93C01F;}\n\t.st65{fill:#273C5C;}\n\t.st66{fill:#3D3F68;}\n\t.st67{fill:#7FC0FF;}\n\t.st68{fill:#102A54;}\n\t.st69{fill:#181936;}\n\t.st70{fill:#006663;}\n\t.st71{fill:#2A2F58;}\n\t.st72{fill:#008080;}\n\t.st73{fill:#06183C;}\n\t.st74{fill:#673438;}\n\t.st75{fill:#21263D;}\n\t.st76{fill:#F99747;}\n\t.st77{fill:#7E9BC1;}\n\t.st78{fill:#6E85B4;}\n\t.st79{fill:#9CB6E0;}\n\t.st80{fill:#A36F68;}\n\t.st81{fill:#8E5C57;}\n\t.st82{display:none;opacity:0.1;fill:#008080;}\n\t.st83{opacity:0.1;fill:#008080;}\n\t.st84{clip-path:url(#XMLID_2_);fill:#E57492;}\n\t.st85{opacity:0.52;}\n\t.st86{opacity:0.3;clip-path:url(#XMLID_3_);fill:#096866;}\n\t.st87{clip-path:url(#XMLID_3_);fill:#096866;}\n\t.st88{opacity:0.3;clip-path:url(#XMLID_4_);fill:#096866;}\n\t.st89{clip-path:url(#XMLID_4_);fill:#096866;}\n\t.st90{clip-path:url(#XMLID_5_);fill:#1C056D;}\n\t.st91{clip-path:url(#XMLID_6_);fill:#8E5C57;}\n\t.st92{clip-path:url(#XMLID_7_);fill:#1C056D;}\n\t.st93{clip-path:url(#XMLID_8_);fill:#8E5C57;}\n\t.st94{clip-path:url(#XMLID_9_);}\n\t.st95{clip-path:url(#XMLID_10_);fill:#DB7D37;}\n\t.st96{clip-path:url(#XMLID_11_);fill:#008080;}\n\t.st97{opacity:0.37;clip-path:url(#XMLID_12_);fill:#D4DFFF;}\n\t.st98{fill:#096866;}\n\t.st99{clip-path:url(#XMLID_13_);fill:#A36F68;}\n\t.st100{fill:#DB7D37;}\n\t.st101{clip-path:url(#XMLID_14_);fill:#DB7D37;}\n\t.st102{clip-path:url(#XMLID_15_);fill:#181936;}\n\t.st103{fill:#D4DFFF;}\n\t.st104{clip-path:url(#XMLID_16_);fill:#096866;}\n\t.st105{fill:#FC476A;}\n\t.st106{clip-path:url(#XMLID_17_);fill:#E57492;}\n\t.st107{fill:#1C056D;}\n\t.st108{fill:#1B3D9E;}\n\t.st109{clip-path:url(#XMLID_18_);fill:#E57492;}\n\t.st110{clip-path:url(#XMLID_19_);fill:#E57492;}\n\t.st111{clip-path:url(#XMLID_20_);fill:#E57492;}\n\t.st112{clip-path:url(#XMLID_20_);fill:#FFFFFF;}\n\t.st113{clip-path:url(#XMLID_21_);fill:#F99747;}\n\t.st114{fill:#FFE0C1;}\n\t.st115{clip-path:url(#XMLID_22_);fill:#008080;}\n\t.st116{clip-path:url(#XMLID_22_);fill:#096866;}\n\t.st117{clip-path:url(#XMLID_23_);fill:#0F0F0F;}\n\t.st118{opacity:0.12;fill:#008080;}\n\t.st119{opacity:0.41;}\n\t.st120{opacity:0.21;}\n\t.st121{fill:#F6BBBA;}\n\t.st122{fill:#232E33;}\n\t.st123{fill:#60C1D4;}\n\t.st124{fill:#FFDC80;}\n\t.st125{fill:#FEDA80;}\n\t.st126{fill:#F08974;}\n\t.st127{fill:#EA8080;}\n\t.st128{fill:#7E5A54;}\n\t.st129{fill:#54322D;}\n\t.st130{fill:#FBD4B9;}\n\t.st131{fill:#A54667;}\n\t.st132{fill:#F7B283;}\n\t.st133{fill:#F6B699;}\n\t.st134{opacity:0.12;clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#008080;}\n\t.st135{clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#CAE7E4;}\n\t.st136{clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#9FC9D0;}\n\t.st137{clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#243A9D;}\n\t.st138{clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#1486CF;}\n\t.st139{clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#08A4DD;}\n\t.st140{clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#ED7D65;}\n\t.st141{clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#EA684D;}\n\t.st142{clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#F69B6E;}\n\t.st143{clip-path:url(#SVGID_112_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st144{fill:#F5F5F5;}\n\t.st145{fill:#E0E0E0;}\n\t.st146{opacity:0.1;}\n\t.st147{fill:#333333;}\n\t.st148{fill:#27DEBF;}\n\t.st149{opacity:0.2;fill:#333333;enable-background:new    ;}\n\t.st150{opacity:0.15;fill:#333333;enable-background:new    ;}\n\t.st151{fill:#37474F;}\n\t.st152{fill:#263238;}\n\t.st153{fill:#455A64;}\n\t.st154{opacity:0.75;fill:#FFFFFF;enable-background:new    ;}\n\t.st155{opacity:0.5;fill:#333333;enable-background:new    ;}\n\t.st156{opacity:0.3;fill:#333333;enable-background:new    ;}\n\t.st157{opacity:0.6;fill:#333333;enable-background:new    ;}\n\t.st158{opacity:0.4;fill:#333333;enable-background:new    ;}\n\t.st159{opacity:0.45;fill:#333333;enable-background:new    ;}\n\t.st160{opacity:0.15;fill:#27DEBF;enable-background:new    ;}\n\t.st161{opacity:0.3;fill:#27DEBF;enable-background:new    ;}\n\t.st162{fill:#FAFAFA;}\n\t.st163{fill:#EBEBEB;}\n\t.st164{opacity:0.5;}\n\t.st165{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\n\t.st166{fill:#F28F8F;}\n\t.st167{opacity:0.8;fill:#455A64;enable-background:new    ;}\n\t.st168{opacity:0.4;}\n\t.st169{fill:#FFA8A7;}\n\t.st170{fill:none;stroke:#E0E0E0;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st171{fill:#FAFAFA;stroke:#E0E0E0;stroke-width:0.92;stroke-miterlimit:10;}\n\t.st172{opacity:0.1;fill:#333333;enable-background:new    ;}\n\t.st173{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\n\t.st174{opacity:0.2;}\n\t.st175{fill:#F0F0F0;}\n\t.st176{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\n\t.st177{fill:#B16668;}\n\t.st178{opacity:0.85;fill:#FFFFFF;enable-background:new    ;}\n\t.st179{opacity:0.6;}\n\t.st180{opacity:3.000000e-02;fill:#FFFFFF;enable-background:new    ;}\n\t.st181{fill:#EAF2FC;}\n\t.st182{clip-path:url(#XMLID_24_);fill:#D4DFFF;}\n\t.st183{clip-path:url(#XMLID_25_);fill:#FFFFFF;}\n\t.st184{clip-path:url(#XMLID_25_);fill:#008080;}\n\t.st185{opacity:0.3;clip-path:url(#XMLID_26_);fill:#6880E4;}\n\t.st186{opacity:0.3;clip-path:url(#XMLID_27_);fill:#6880E4;}\n\t.st187{clip-path:url(#XMLID_28_);fill:#F99747;}\n\t.st188{clip-path:url(#XMLID_29_);fill:#8E5C57;}\n\t.st189{clip-path:url(#XMLID_29_);fill:#FFFFFF;}\n\t.st190{clip-path:url(#XMLID_30_);fill:#8E5C57;}\n\t.st191{clip-path:url(#XMLID_31_);fill:#008080;}\n\t.st192{fill:#FE8E9C;}\n\t.st193{clip-path:url(#XMLID_32_);fill:#008080;}\n\t.st194{clip-path:url(#XMLID_33_);fill:#1C056D;}\n\t.st195{clip-path:url(#XMLID_34_);fill:#E57492;}\n\t.st196{fill:#E57492;}\n\t.st197{clip-path:url(#XMLID_35_);fill:#F99747;}\n\t.st198{opacity:0.3;clip-path:url(#XMLID_36_);fill:#F99747;}\n\t.st199{opacity:0.27;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M311.7,504.2c44.8,4.6,89.9,6.4,134.1,7.1c104.3,1.8,208.8-6.7,311.5-25.4c70.6-12.8,131.7-41.8,143.9-118.7 c15.8-99.8-33-225.9-141.9-244.6c-33.7-5.8-68.7-5.5-101-16.6c-48.2-16.4-85.7-55.5-136.7-64.8c-52.1-9.4-110,1.7-151.8,36.6 c-18.4,15.3-34.1,33.3-48.8,52.1c-11.4,14.6-21.9,32.8-39.2,41c-21.2,10.1-45.9,2.1-69.2-1c-39.9-5.3-86.9,7.6-116.7,35.3 C64.7,234.3,55.4,288,59.6,328.3c5.5,52.8,31.6,102.4,76.8,131.6C187.4,492.9,252.8,498.2,311.7,504.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M631.2,23.9c-49.9-4.3-102.9,6.2-142.7,35.3c-24.6,18-41.4,46.5-71.2,56.9c-24.2,8.4-50.7,2.3-75.8-2.9 c-71.9-15.2-151.6-2.3-204.8,51.4C73,228.8,68.4,328.6,89.1,411.7c11.4,46,37.8,88.5,82,108.2c71.1,31.7,149.7,11.1,221.1-7.6 c42.4-11.1,85.5-20.3,129.3-23c43.7-2.7,87.5,1.8,131.2,3.5c100.8,3.7,214.4-29.4,230-144.2c9.6-70.7-17-149-57-206.7 c-35.1-50.6-86.3-90.7-145.2-108.6C664.8,28.5,648.2,25.3,631.2,23.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st181",
    d: "M251.2,361.8c-40.2,0-72.9-32.7-72.9-72.9S211,216,251.2,216c40.2,0,72.9,32.7,72.9,72.9 S291.4,361.8,251.2,361.8z M378.4,269h-19.9c-2.8-15.1-8.7-29.3-17.4-41.9l14-14c1.8-1.8,1.8-4.6,0-6.4l-21.8-21.8 c-1.8-1.8-4.6-1.8-6.4,0l-14,14c-12.6-8.7-26.8-14.6-41.9-17.4v-19.9c0-2.5-2-4.5-4.5-4.5h-30.8c-2.5,0-4.5,2-4.5,4.5v19.9 c-15.1,2.8-29.3,8.7-41.9,17.4l-14-14c-1.8-1.8-4.6-1.8-6.4,0l-21.8,21.8c-1.8,1.8-1.8,4.6,0,6.4l14,14 c-8.7,12.6-14.6,26.8-17.4,41.9H124c-2.5,0-4.5,2-4.5,4.5v30.8c0,2.5,2,4.5,4.5,4.5h19.9c2.8,15.1,8.7,29.3,17.4,41.9l-14,14 c-1.8,1.8-1.8,4.6,0,6.4l21.8,21.8c1.8,1.8,4.6,1.8,6.4,0l14-14c12.6,8.7,26.8,14.6,41.9,17.4v19.9c0,2.5,2,4.5,4.5,4.5h30.8 c2.5,0,4.5-2,4.5-4.5v-19.9c15.1-2.8,29.3-8.7,41.9-17.4l14,14c1.8,1.8,4.6,1.8,6.4,0l21.8-21.8c1.8-1.8,1.8-4.6,0-6.4l-14-14 c8.7-12.6,14.6-26.8,17.4-41.9h19.9c2.5,0,4.5-2,4.5-4.5v-30.8C382.9,271,380.9,269,378.4,269z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st181",
    d: "M605.2,423.8c-14.9,0-27-12.1-27-27s12.1-27,27-27c14.9,0,27,12.1,27,27S620.1,423.8,605.2,423.8z  M652.3,389.4h-7.3c-1-5.6-3.2-10.8-6.4-15.5l5.2-5.2c0.7-0.7,0.7-1.7,0-2.4l-8.1-8.1c-0.7-0.7-1.7-0.7-2.4,0l-5.2,5.2 c-4.7-3.2-9.9-5.4-15.5-6.4v-7.3c0-0.9-0.7-1.7-1.7-1.7h-11.4c-0.9,0-1.7,0.7-1.7,1.7v7.3c-5.6,1-10.8,3.2-15.5,6.4l-5.2-5.2 c-0.7-0.7-1.7-0.7-2.4,0l-8.1,8.1c-0.7,0.7-0.7,1.7,0,2.4l5.2,5.2c-3.2,4.7-5.4,9.9-6.4,15.5h-7.3c-0.9,0-1.7,0.7-1.7,1.7v11.4 c0,0.9,0.8,1.7,1.7,1.7h7.3c1,5.6,3.2,10.8,6.4,15.5l-5.2,5.2c-0.7,0.7-0.7,1.7,0,2.4l8.1,8.1c0.7,0.7,1.7,0.7,2.4,0l5.2-5.2 c4.7,3.2,9.9,5.4,15.5,6.4v7.3c0,0.9,0.7,1.7,1.7,1.7h11.4c0.9,0,1.7-0.7,1.7-1.7v-7.3c5.6-1,10.8-3.2,15.5-6.4l5.2,5.2 c0.7,0.7,1.7,0.7,2.4,0l8.1-8.1c0.7-0.7,0.7-1.7,0-2.4l-5.2-5.2c3.2-4.7,5.4-9.9,6.4-15.5h7.3c0.9,0,1.7-0.7,1.7-1.7v-11.4 C653.9,390.2,653.2,389.4,652.3,389.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_358_",
    d: "M340.6,489.6c0,0,3.8,27.3,16.3,45.5c-8.3-8-25.3-20.4-57.3-30.9c0,0,9.5,30.9,37.6,47.1 c-9.4-2.6-22-5-37.6-5.7c0,0,20.9,28.9,49.7,32.4h54.4C403.7,577.9,404.2,512.8,340.6,489.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_358_",
    style: {
      overflow: "visible",
      fill: "#008080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_358_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_2_)",
      fill: "#D4DFFF"
    },
    d: "M396.7,582.2c-0.1,0-0.3-0.1-0.3-0.2c-10.3-28.1-25-51.7-35.5-66.5 c-11.4-16.1-20.4-25.6-20.5-25.7c-0.1-0.1-0.1-0.3,0-0.5c0.1-0.1,0.3-0.1,0.5,0c0.1,0.1,9.1,9.7,20.5,25.8 c10.5,14.9,25.2,38.5,35.6,66.7c0.1,0.2,0,0.4-0.2,0.4C396.8,582.2,396.7,582.2,396.7,582.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_2_)",
      fill: "#D4DFFF"
    },
    d: "M381.3,583c-0.1,0-0.2-0.1-0.3-0.2c-6.9-11.1-80.8-77.8-81.6-78.5 c-0.1-0.1-0.1-0.3,0-0.5c0.1-0.1,0.3-0.1,0.5,0c3,2.8,74.7,67.5,81.7,78.6c0.1,0.2,0.1,0.4-0.1,0.5C381.4,583,381.3,583,381.3,583z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_2_)",
      fill: "#D4DFFF"
    },
    d: "M380.1,581.5C380.1,581.5,380.1,581.5,380.1,581.5 c-18.8-3.7-80-35.3-80.6-35.6c-0.2-0.1-0.2-0.3-0.1-0.4c0.1-0.2,0.3-0.2,0.4-0.1c0.6,0.3,61.7,31.9,80.4,35.6 c0.2,0,0.3,0.2,0.3,0.4C380.4,581.3,380.3,581.5,380.1,581.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_357_",
    d: "M525,577.6c0,0-10.4-46.9,64.6-112c0,0-9.5,66.2-30.4,93.4c0,0,1.9-26,49.9-60.6c0,0-2.8,48.9-35.6,68.9 c-32.8,19.9-4.7,1.4-4.7,1.4s25.2-27.7,53.7-38.1c0,0-22.3,42.8-48.9,47.3L525,577.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_357_",
    style: {
      overflow: "visible",
      fill: "#008080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_357_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_3_)",
      fill: "#FFFFFF"
    },
    d: "M535,583.7c0,0-0.1,0-0.1,0c-0.2-0.1-0.3-0.3-0.2-0.4 c0.4-1,40.8-100,54.7-117.8c0.1-0.1,0.3-0.2,0.5-0.1c0.1,0.1,0.2,0.3,0.1,0.5c-13.8,17.7-54.2,116.7-54.6,117.7 C535.2,583.7,535.1,583.7,535,583.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_3_)",
      fill: "#008080"
    },
    d: "M550.6,579.8c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.4,0.1-0.5 c12.2-9,57.9-80.2,58.4-81c0.1-0.2,0.3-0.2,0.5-0.1c0.2,0.1,0.2,0.3,0.1,0.5c-0.1,0.2-11.7,18.2-24.6,37.1 c-17.4,25.4-28.8,40.2-33.9,44C550.8,579.8,550.7,579.8,550.6,579.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_3_)",
      fill: "#008080"
    },
    d: "M561.9,579.8c-0.1,0-0.3-0.1-0.3-0.2c-0.1-0.2,0-0.4,0.2-0.4 c5.9-2.6,18.2-11.8,35.6-26.8c13.2-11.3,24.7-22,24.8-22.1c0.1-0.1,0.3-0.1,0.5,0c0.1,0.1,0.1,0.3,0,0.5 c-0.1,0.1-11.7,10.8-24.8,22.1c-17.7,15.2-29.7,24.2-35.8,26.9C562,579.8,561.9,579.8,561.9,579.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_356_",
    d: "M556,282.8H272.5c0,0,5.3,30.5,4.7,36.4c-0.6,5.9-54.2,92.7-36.8,90c36.1-5.7,42.1-5.4,42.1-5.4 s-12.9,70.4,0,78.1c12.9,7.6,101-4.1,101-4.1l-11.7,100h170.2l-14-116.1c-3-25.1-0.6-50.5,7-74.5 C545.6,353.9,559,305.8,556,282.8z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_356_",
    style: {
      overflow: "visible",
      fill: "#D4DFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_356_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      clipPath: "url(#XMLID_4_)",
      fill: "#6880E4"
    },
    d: "M277,466.3c0,0,5.1,11.5,35.2,3.8s114.4-38.8,114.9-29.6 c0.5,9.1-52.3,111.4-52.3,111.4s3.1-63.9-0.1-65.3c-3.2-1.4-87.6,18.2-95.8,3.6C270.7,475.6,277,466.3,277,466.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      clipPath: "url(#XMLID_4_)",
      fill: "#6880E4"
    },
    d: "M238.1,408.8c0,0-0.3-3.9,7-8c7.3-4.2,43-2.2,43,0.2 c0,2.4-10.6,41.1-10.4,38.4c0.2-2.7,2.8-29.9,0.4-30.8C275.6,407.6,236.2,412.7,238.1,408.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      clipPath: "url(#XMLID_4_)",
      fill: "#6880E4"
    },
    d: "M556,282.8c0,0-45,98.9-46.1,141.3 c-1.1,42.4,37.3,112,37.3,112s-13.6-86-10.2-108.6c3.4-22.6,30.6-144.7,30.6-144.7L556,282.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      clipPath: "url(#XMLID_4_)",
      fill: "#6880E4"
    },
    d: "M293.1,279.6c0,0,19.3,35.4,43.5,40 c24.2,4.6,72-36.8,72-36.8L293.1,279.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_355_",
    d: "M615.6,310.4L469.9,86.7c0,0,96.6-84.8,193.4,39.9C753.4,242.7,615.6,310.4,615.6,310.4z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_355_",
    style: {
      overflow: "visible",
      fill: "#D4DFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_355_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      clipPath: "url(#XMLID_5_)",
      fill: "#6880E4"
    },
    d: "M556.4,255.7c0,0,73.7,3.7,93.9-30.4 c20.2-34.1,8.8-104,8.8-104s38.9,33.1,47.4,76.1c8.5,43-59.3,119-86.1,126C620.5,323.4,571.9,279.2,556.4,255.7z"
  })), /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M745.9,559.8c0,0-0.6-5.2-0.6-10c0-4.8,0-11.7,0-11.7l-21,0.4c0,0,2.8,15.7,2.8,16.5s-4.6,4-4.6,4 s7.4,6.7,10.9,6.4C737,565.3,745.9,559.8,745.9,559.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M745.9,559.8l2.7,13.9c0.2,2.1-1.5,3.9-3.6,3.9h-53.9c0,0-0.2-3.1,1.2-6.3s28.9-11,30.1-12.2c0,0,9.2,3.1,12.9,3.1 C739,562.2,745.9,559.8,745.9,559.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M700.8,560.1c0,0-0.6-5.2-0.6-10c0-4.8,0-11.7,0-11.7l-21,0.4c0,0,2.8,15.7,2.8,16.5c0,0.8-4.6,4-4.6,4 s7.4,6.7,10.9,6.4C691.8,565.5,700.8,560.1,700.8,560.1z"
  })), /*#__PURE__*/React.createElement("g", null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M730.1,384.2c0,0,23.9,149.3,21.1,153.3c-2.8,3.9-31.9,3.9-31.9,3.9s-25.2-107.3-25.5-128.6 C693.6,391.6,730.1,384.2,730.1,384.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_354_",
    d: "M730.1,329.7c0,0,14.3,16.7,0,54.6S707.9,542.5,703,543.6s-27.9,1.3-29.2,0s-3.7-110.6-3.1-124 c0.6-13.4,8.5-90,8.5-90H730.1z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_354_",
    style: {
      overflow: "visible",
      fill: "#F99747"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_354_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_6_)",
      fill: "#F99747"
    },
    d: "M687.6,546.9C687.6,546.9,687.6,546.9,687.6,546.9 c-0.5,0-0.8-0.4-0.8-0.8c0-1,3.4-103.3,6.9-125.9c3.5-22.5,13.2-90.7,13.3-91.3c0.1-0.4,0.5-0.7,0.9-0.7 c0.4,0.1,0.7,0.5,0.7,0.9c-0.1,0.7-9.8,68.8-13.3,91.4c-3.5,22.5-6.8,124.6-6.8,125.7C688.4,546.5,688.1,546.9,687.6,546.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M683.4,346.3c0,0,3.2,18.3,15.9,23.3l1-2.6c0,0-12.8-9.6-13.8-22.2L683.4,346.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M671.7,538c0-0.6,0.4-1.2,1.1-1.2c6-0.3,33.2-1.5,33.3,0.1c0.1,1.7-0.1,6.9-1.3,7.7 c-1.2,0.7-14,1.6-17.1,1.6c-3.2,0-14.5-0.5-15.1-1.6C672.1,543.7,671.8,540,671.7,538z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M714.9,536.5c-0.1-0.6,0.4-1.3,1.1-1.4c6.8-1.1,37.5-5.7,37.8-4.2c0.3,1.7,0.6,6.9-0.6,7.8 c-1.3,0.9-15.7,3.4-19.2,3.8c-3.6,0.4-16.4,1.4-17.3,0.4C716,542.1,715.2,538.4,714.9,536.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_353_",
    d: "M727.7,162.9c-2.5-8.3-28.4-19-32.7-8.3c0,0,1,16.5-5.2,17.9c-6.2,1.4-14.1,0.3-11.3,2.9 c2.8,2.5,9,3.2,9.3,5.3c0.3,2-4,12.3,0.8,14.2c1.9,0.8,4.1,0.6,8.3,0.5c-1.2,6.1-3.6,19-3.7,21.2c-0.1,2.9,21.1,3.1,25.1,0.8 c4-2.4-5.9-24.9-5.9-24.9C715,189.6,730.3,171.1,727.7,162.9z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_353_",
    style: {
      overflow: "visible",
      fill: "#A36F68"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_353_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_7_)",
      fill: "#8E5C57"
    },
    d: "M697,195.4c0,0,4.5-0.1,7.6-2.2c0,0-3.8,6.9-9.4,6.4 C695.1,199.5,695.2,196.1,697,195.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_7_)",
      fill: "#8E5C57"
    },
    d: "M695.1,161.5c0,0,15.4,6.3,23.3,2c7.8-4.3-22.1-9.1-22.1-9.1 L695.1,161.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_7_)",
      fill: "#FFFFFF"
    },
    d: "M686.9,183.8c0,0,6.3,0.5,8.7-1c0,0-4.7,6.1-9.5,5.3 C686,188.1,686,185.3,686.9,183.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M741.2,164.1c0-13.2-18.7-16.6-18.7-16.6s-5.8-9.5-22.4-8.7c-8.3,0.4-5.5,2-0.7,3.6 c-4.9-0.5-10.3-0.1-14,3.4c-5.9,5.4,2.8,4.6,8.7,3.6c-0.1,0.2-0.1,0.3-0.2,0.5c-4.6,1.6-10.5,4.3-8.9,7.6 c1.4,2.8,6.1,2.3,10.3,1.3c3.4,2,15.3,3.5,15.3,3.5s-5,12.2-5,13.5c0,1.2,3.1-5.4,6.3-2.1c1.1,1.1-0.5,6.7-2.6,7.3 c-2.2,0.7-4-1-4-1s1.3,11.4,7.4,12.5c4.3,0.8,13.8-7.9,18.9-17.4c1.7,2.4,3.4,3.5,4-0.8c0.5-3.2-0.1-6-0.9-8.2c0-0.1,0-0.2,0-0.4 C737.6,169.1,741.1,171.5,741.2,164.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M700.8,560.1l2.7,13.9c0.2,2.1-1.5,3.9-3.6,3.9H646c0,0-0.2-3.1,1.2-6.3s28.9-11,30.1-12.2c0,0,9.2,3.1,12.9,3.1 S700.8,560.1,700.8,560.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M672.1,561.4c0,0,2.5,1.9,2.7,3.2c0.1,0.8-0.6,1-1.1,0.9c-0.3,0-0.6-0.1-0.9-0.4l-3.1-2.9 C669.6,562.2,670.4,560.9,672.1,561.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M666.4,563.2c0,0,2.5,1.9,2.7,3.2c0.1,0.8-0.6,1-1.1,0.9c-0.3,0-0.6-0.1-0.9-0.4L664,564 C664,564,664.8,562.7,666.4,563.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M661.3,565.3c0,0,2.5,1.9,2.7,3.2c0.1,0.8-0.6,1-1.1,0.9c-0.3,0-0.6-0.1-0.9-0.4l-3.1-2.9 C658.8,566.1,659.6,564.8,661.3,565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M655.8,567.4c0,0,2.5,1.9,2.7,3.2c0.1,0.8-0.6,1-1.1,0.9c-0.3,0-0.6-0.1-0.9-0.4l-3.1-2.9 C653.3,568.2,654.1,566.9,655.8,567.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_352_",
    d: "M597.1,263.6c0,0-6.9-3.1-7.3-3.7c-0.4-0.6-3.9-15.6-5.8-16.6s1,9.9,0,10.7c-1,0.9-10.7-8.8-10.7-8.8 s0,12.8,3.5,17c2,2.4,14.1,12.2,14.1,12.2L597.1,263.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_352_",
    style: {
      overflow: "visible",
      fill: "#8E5C57"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_352_",
    style: {
      overflow: "visible"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M573,247.5c0.3,0.1,4.1,6.4,4.6,8.3c0.5,1.9-4.7-6.2-4.7-6.8S573,247.5,573,247.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M573.2,254.3c0,0,4.3,6.6,4.2,7s-4.9-4.1-4.7-5.2C573,254.9,573.2,254.3,573.2,254.3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M737.1,240c-1.5-11.1-17.8-25.6-17.8-25.6c-4.9,5.3-26.1,2.4-26.1,2.4s-25.1,35.8-37.8,70.2 c0,0-20.1-15.9-58-24.7l-7.9,13.8c0,0,57.2,51.6,75.6,45.9c4.2-1.3,9-4.9,13.8-9.7c-1.1,11.5-1.8,20.8-1,22.9 c2.1,5.3,24.6-1.1,39.3-2.3c14.7-1.3,17.2-0.2,12.4-10.4C724.9,312.3,738.6,251.2,737.1,240z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M679,312.3c0,0,26.4-32,30.7-47c0,0-14.5,52.3-31.7,58L679,312.3z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_351_",
    d: "M383.1,221.7c0,0,36.3,27,42.4,25.7c6.1-1.3,35.6-44.3,35.6-44.3l13.7,8.9c0,0-23.6,65.1-35.6,67.3 c-12,2.2-39.5-5.7-39.5-5.7L383.1,221.7z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_351_",
    style: {
      overflow: "visible",
      fill: "#008080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_351_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_9_)",
      fill: "#008080"
    },
    d: "M383.1,221.7c0,0,34.5,37.4,38.8,57.9l-28.1-3.3 C393.8,276.3,379.8,230.6,383.1,221.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_9_)",
      fill: "#008080"
    },
    d: "M472.3,209.2c0,0-16.2,17.1-20.9,27.6c0,0,3.8,5.1,2,10.9 c-1.8,5.8-4,5.7-4,5.7s4,8.9-7.2,11c0,0-0.1,8.8-13.7,9.2s0,0,0,0l-1.3-19.1l32.7-49.5C459.9,204.9,469.4,204.6,472.3,209.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M473.6,211.2c0,0,4.8-7.4,5.5-8.1c0.7-0.7,9.8-9.6,9.3-10.2c-1.7-2.2-10,6.2-10,6.2l-9.6,9L473.6,211.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M461.1,203.1c0,0,14.9,8.1,14.9,9.2c0,1.1-2,6.6-3.1,6.2c-1.1-0.4-15.8-8.5-15.7-10.3 C457.4,206.5,461.1,203.1,461.1,203.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_350_",
    d: "M327.2,202c0,0-31.4,26.3-32.4,41.3c-1.1,15.1,16.2,39.5,16.2,39.5h97.5c0,0-15.9-51.7-25.4-61.1 c-9.5-9.4-30.3-16.4-30.3-16.4L327.2,202z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_350_",
    style: {
      overflow: "visible",
      fill: "#008080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_350_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#XMLID_10_)",
      fill: "#008080"
    },
    points: "404.7,271.1 389.1,283.9 409.8,283.5 404.7,271.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_349_",
    d: "M357.6,130.2c2.5-0.4,5.2-0.1,7.5,1.1c2.3,1.2,4.2,3.2,5,5.6c1.3,3.9,0,8.5,1.6,12.3 c1,2.3,3.1,4.1,4.3,6.3c0.9,1.7,1.4,3.6,1.2,5.5c-0.3,4.7-3.7,8.5-7.3,11.5c-1.1-2.4-3.1-4.3-4.9-6.1 c-5.8-5.8-11.4-12.2-13.7-20c-0.8-2.6-1.1-5.4-0.6-8.1c0.2-1.3,0.7-2.6,1.4-3.8c0.3-0.4,0.4-0.9,0.7-1.4 c0.3-0.5,0.7-0.9,1.1-1.3C354.9,130.9,356.3,130.4,357.6,130.2z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_349_",
    style: {
      overflow: "visible",
      fill: "#1B3D9E"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_349_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_11_)",
      fill: "#1C056D"
    },
    d: "M376.3,171.3c0,0-5.3-19.1-8.9-21.5c-3.7-2.4,1.7,24.2,2.4,23.9 C370.6,173.5,374.7,173.4,376.3,171.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_348_",
    d: "M335.4,148.6c3-3.5,13.7-7.3,22.5-5.7c4.9,0.9,8.7,4.8,9.8,9.7c2.4,11,7.2,37.1-0.7,39.5 c-3.5,1.1-7.6,0.2-11.6-1.5c-0.8,6.7-4,22-4.6,24.1c-0.8,2.9-19.9-7-23.2-10.4c-2.1-2.2,12.4-26.1,12.4-26.1 C338.1,173.6,331.3,153.4,335.4,148.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_348_",
    style: {
      overflow: "visible",
      fill: "#FE8E9C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_348_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_12_)",
      fill: "#E57492"
    },
    d: "M355.4,190.6c0,0-5.2-3.5-9.5-7.7c0,0,0.1,18.7,8.8,20.2L355.4,190.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_12_)",
      fill: "#E57492"
    },
    d: "M366.3,158c-1.6,1.2-3.7,1.9-5.6,1.4c-0.5-0.1-1-0.3-1.4-0.5 c-0.2-0.1-0.5-0.2-0.7-0.4c-0.2-0.2-0.3-0.5-0.1-0.7c-2,1.7-4.8,2.3-7.3,1.8c-2.4,1.9-4.9,4.1-5.6,7c-0.8-2.3-0.5-4.8,0.4-7 c0.9-2.2,2.4-4.2,4-5.9c0.8-0.8,1.6-1.6,2.6-2.2c2.1-1.4,4.8-1.7,7.3-1.8c1.9-0.1,3.9,0,5.7,0.6c1.4,0.4,2.9,1.2,3.9,2.4 c0.2,0.2,0.3,0.5,0.3,0.8c-0.1,0.3-0.2,0.6-0.4,0.8c-0.4,0.7-0.8,1.4-1.2,2C367.6,156.8,367,157.5,366.3,158z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st196",
    d: "M362.9,162.5c0,0,5.6,9,4.4,10.5c-1.2,1.5-4.2-2.1-5.1-1.8c-0.9,0.2-1.4,1.7-0.2,1.9 c1.1,0.2,5.5,2.3,5.9,0.3C368.3,171.2,367.5,169.6,362.9,162.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M369.6,178.3c0,0-2.9,2.9-7.3-0.4c0,0,0.3,2.8,3.3,3.3C369.5,181.8,369.6,178.3,369.6,178.3z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M327.2,140.9c3.7-2.4,9-5.9,14.7-7.7c-0.2-0.1-0.4-0.2-0.5-0.3c-1.8-1-3.2-2.8-3.7-4.9 c-0.5-2,0-4.3,1.3-5.9c1-1.2,2.3-2.1,3.7-2.7c1.4-0.6,2.8-1,4.3-1c3-0.1,6.1,1.5,7.7,4.1c1.6,2.6,1.7,6.1,0,8.7 c-0.4,0.6-0.8,1.1-1.4,1.5c-0.1,0-0.1,0.1-0.2,0.1c2.5,0.7,4.9,2.1,7.1,4.4c10.8,11.1,7,12.6,7,12.6s1.3,5.9-6,6.8 c-4.5,0.6-3.2-1.1-1.6-2.5c-2.6,1.9-7,4.7-8.9,4.7c-2.8,0,1.9-5.6,1.9-5.6s-8.9,8.8-7.9,12.8c0,0-1.4-5.9-3.6-5.3 c-2.2,0.7-3,4.5-2,6.9c1.1,2.4,6,2.1,6,2.1l-5.9,9.3c0,0-6.4,2.5-12.1-6.6C321.5,163.4,319.6,145.8,327.2,140.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M354.8,131.2c0,0-3.7,4.4-12.9,2.1l-4.4,1.7C337.5,134.9,349,141.8,354.8,131.2z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M348.6,215c0,0-0.4,14.5-6.9,12c-6.4-2.5-24.2-16.1-14.6-25c0,0,2.3,1.7,3.7,2.6 C332.3,205.4,348.6,215,348.6,215z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M350.8,214.6c0,0,4.8,8.2,7.2,6.9c2.4-1.3,1.3-12.7,0.7-13.1c-0.6-0.4-3.7-3.1-5.9-3.2L350.8,214.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M408.5,254.4c0,0-7.2,12.2,12.3,18.5c0,0,15.3,4.3,20-10.2L408.5,254.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_347_",
    d: "M480.4,99.3c0,0-50.6-25.2-72.4,22.9c-23,50.7,9.7,72.7,7.6,107.4l30.4,8c0,0,7.6-16.7,28.9-34.3 C500.8,182,522.1,125,480.4,99.3z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_347_",
    style: {
      overflow: "visible",
      fill: "#F99747"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_347_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_13_)",
      fill: "#F99747"
    },
    d: "M401.9,180.4c0,0,21.7,32,34.2,34.2c12.5,2.2,38.6-7.2,38.6-7.2 s-26,34.3-28.3,34.4c-2.3,0.1-31.7-7.7-32.5-8.8C413.1,231.8,402.3,182.8,401.9,180.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_346_",
    d: "M450.9,246.4L450.9,246.4c1-3.8-1.3-7.8-5.1-8.8l-30.7-8.1c-3.8-1-7.8,1.3-8.8,5.1l0,0 c-0.6,2.2-0.1,4.5,1.3,6.2c-2,0.8-3.6,2.5-4.2,4.8c-1,3.8,1.3,7.8,5.1,8.8l30.7,8.1c3.8,1,7.8-1.3,8.8-5.1 c0.6-2.2,0.1-4.5-1.3-6.2C448.7,250.4,450.3,248.6,450.9,246.4z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_346_",
    style: {
      overflow: "visible",
      fill: "#6880E4"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_346_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      clipPath: "url(#XMLID_14_)",
      fill: "#F99747"
    },
    d: "M405.2,235.6c0,0,4.3,3,9.9,4.8c5.6,1.9,33.2,6,35.7,5.9 c2.5,0,0,0,0,0s-0.3,4.1-4.2,4.8c-3.9,0.7,0,0,0,0s2.5,2,1.7,4.6s0,0,0,0s-28.8-7.3-29.7-7.4s-16.7-2.3-16.7-2.3 s1.8-6.3,3.7-5.8C405.6,240.4,404.2,236.6,405.2,235.6z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M446.9,171c-8.9-2.4-14.3-11.5-11.9-20.5s11.5-14.3,20.5-11.9c8.9,2.4,14.3,11.5,11.9,20.5 C465,168,455.8,173.3,446.9,171z M480.6,157.8l-4.4-1.2c0.3-3.5-0.2-7-1.4-10.3l3.9-2.3c0.5-0.3,0.7-0.9,0.4-1.4l-3.6-6.1 c-0.3-0.5-0.9-0.7-1.4-0.4l-3.9,2.3c-2.3-2.7-5.1-4.8-8.3-6.3l1.2-4.4c0.1-0.6-0.2-1.1-0.7-1.3l-6.8-1.8 c-0.6-0.1-1.1,0.2-1.3,0.7l-1.2,4.4c-3.5-0.3-7,0.2-10.3,1.4l-2.3-3.9c-0.3-0.5-0.9-0.7-1.4-0.4l-6.1,3.6 c-0.5,0.3-0.7,0.9-0.4,1.4l2.3,3.9c-2.7,2.3-4.8,5.1-6.3,8.3l-4.4-1.2c-0.6-0.1-1.1,0.2-1.3,0.7l-1.8,6.8 c-0.1,0.6,0.2,1.1,0.7,1.3l4.4,1.2c-0.3,3.5,0.2,7,1.4,10.3l-3.9,2.3c-0.5,0.3-0.7,0.9-0.4,1.4l3.6,6.1c0.3,0.5,0.9,0.7,1.4,0.4 l3.9-2.3c2.3,2.7,5.1,4.8,8.3,6.3l-1.2,4.4c-0.1,0.6,0.2,1.1,0.7,1.3l6.8,1.8c0.6,0.1,1.1-0.2,1.3-0.7l1.2-4.4 c3.5,0.3,7-0.2,10.3-1.4l2.3,3.9c0.3,0.5,0.9,0.7,1.4,0.4l6.1-3.6c0.5-0.3,0.7-0.9,0.4-1.4l-2.3-3.9c2.7-2.3,4.8-5.1,6.3-8.3 l4.4,1.2c0.6,0.1,1.1-0.2,1.3-0.7l1.8-6.8C481.5,158.5,481.1,157.9,480.6,157.8z"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M311,282.8c0,0,13.1,28.6,37.6,24c24.5-4.6,69.1-47.4,69.1-47.4l-5.1-17c0,0-58.4,25.8-61,23s-18-23-18-23 S304.2,268.1,311,282.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M396.9,249.2c0,0-36.9,15.8-45.3,16.2S334.1,246,334.1,246s11.5,15.3,16.7,14.5c5.2-0.8,44.3-15.9,44.3-15.9 L396.9,249.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M413.6,245.4c0,0,3.4-2,4.1-2.4s8.8-10.4,10.2-10.1c3,0.8-4.5,9.3-1.2,9.4c0,0,19-2.7,19.1-1.6 c0.1,1.2-7.4,3.6-14.3,5.2c0,0,16.9-2.5,19.5-1.4c2.6,1.1-16.6,6-17.4,6c-0.8,0,14-1.1,15.1,0c1.1,1.1-16.8,3.7-16.8,3.7 s8.3,2.9,8.8,3.9c0.5,0.9-14-1.6-16.4-1.6s-7.3,0.6-7.3,0.6L413.6,245.4z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M412.7,242.4c0,0,5.8,17,5.7,17.9c-0.2,0.9-5.6,4.9-5.9,4c-0.4-0.9-6.1-18-5.9-19.2 C406.7,243.8,412,241.8,412.7,242.4z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st199"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M852,56.4c-2.2-4.3-101-0.9-102.3,0c-5.9,4.3-0.5,57.6,0,59.7c0.1,0.5,5.7,0.8,14.1,1 c-4,10.8-9,24.6-8.1,25.2c2.8,1.8,15.8-14.4,26.1-25c29,0.1,67.5-0.6,70.2-1.2C856.3,115,854.2,60.7,852,56.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M772.8,85.9c0.1,2.7-2.1,4.9-4.8,5c-2.7,0.1-4.9-2.1-5-4.8c-0.1-2.7,2.1-4.9,4.8-5 C770.5,81,772.7,83.2,772.8,85.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 171.3856 584.7575)",
    className: "st98",
    cx: 791.6,
    cy: 85.5,
    rx: 4.9,
    ry: 4.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5466 -0.8374 0.8374 0.5466 298.4635 721.2296)",
    className: "st98",
    cx: 815.2,
    cy: 85,
    rx: 4.9,
    ry: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st98",
    cx: 838.9,
    cy: 84.5,
    r: 4.9
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M440.5,80.4c0,0-4.7-40.9,0-59.1C440.5,21.3,443.6,70.2,440.5,80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M417.5,90.8c0,0-11.4-28-32.1-44.7C385.5,46.1,401.2,73.8,417.5,90.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M360.6,87.1c0,0,14,15.2,38.2,20.4C398.8,107.4,376.3,93.8,360.6,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M429.7,82.6c0,0-5.1-21.8-8.8-28C420.9,54.7,420.4,65,429.7,82.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M405.5,97.2c0,0-14.7-16.9-20.8-20.7C384.7,76.6,389.1,86,405.5,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M396.6,118.9c0,0-22.2-2.8-29.3-1.5C367.3,117.4,376.8,121.5,396.6,118.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainThinking01);
export default __webpack_public_path__ + "static/media/brain_thinking-01.72332f27b554a8242666762ed346d18a.svg";
export { ForwardRef as ReactComponent };